//Create New DashboardTemplatesHeader functional component with a heading on left and a CustomButton on right

import React, { useContext } from 'react';
import {
  DashboardsTemplatesHeaderCnt,
  HeaderHeading,
  SubHeading,
} from 'pages/Dashboards/DashboardTemplates/DashboardTemplatesHeader/dashboardTemplatesHeader.style';
const DashboardsTemplatesHeader = () => {
  return (
    <DashboardsTemplatesHeaderCnt>
      <HeaderHeading>Templates</HeaderHeading>
      <SubHeading>Get started with predefined Xenia dashboards.</SubHeading>
    </DashboardsTemplatesHeaderCnt>
  );
};

export default DashboardsTemplatesHeader;
